import './Search-new.css';
import Category from '../Components/Category'
import Manufacturer from '../Components/Manufacturer'
import Loader from '../Components/Loader'
import Pager from '../Components/Pager'
import { useEffect, useRef, useState } from 'react';
import {
  useNavigate,
  useSearchParams
} from "react-router-dom";
import constants from '../Utils/constants';
import Modern from '../Components/Modern/Results';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faFilterCircleXmark, faMagnifyingGlass} from '@fortawesome/free-solid-svg-icons'
import Sorter from '../Components/Sorter';
import PriceFilter from '../Components/PriceFilter';
import SearchHints from '../Components/SearchHints';

const number = /^(\d+([,.]\d*)?)?$/

function checkNum(old, curr) {
  if(number.exec(curr.trim())) {
    return curr.trim().replace(',', '.')
  }
  else {
    return old
  }
}

function categoriesState(category) {
  var c = Object.assign({selected: false, expanded: false}, category)
  c.Children = c.Children.map(categoriesState)
  return c
}

function filterCategories(categories, filter, lastCategoriesRef) {
  if (filter.length < 3)
    return lastCategoriesRef.current
  var ret = [];
  categories.forEach(c => {
    if(c.Nome.toLowerCase().includes(filter.toLowerCase())) {
      var c1 = Object.assign({selected: false, expanded: true}, c)
      ret.push(c1)
    }
    else {      
      var childs = []
      if(c.Children.length > 0) {
        childs = filterCategories(c.Children, filter, lastCategoriesRef)
      }
      if(childs.length > 0) {
        var c1 = Object.assign({selected: false, expanded: true}, c)
        c1.Children = childs
        ret.push(c1)
      }
    }
  });
  return ret
}

function manufacturersState(data, manufacturers) {
  var m = data.map(x => x.Manufacturer).filter((v, i, a) => a.indexOf(v) === i)
  m.sort();
  return m.map(x => {return {selected: manufacturers.includes(x), manufacturer: x} })
}

function selectManufacturer(manufacturers, n) {
  return manufacturers.map(x => x.manufacturer === n ? Object.assign({}, x, {selected: !x.selected}) : x);
}

function getSelectedManufacturers(manufacturers) {
  return manufacturers.filter(x => x.selected).map(x => x.manufacturer);
}

function selectCategory(category, ID) {
  var c = Object.assign({}, category)
  if(category.ID === ID) {
    c.selected = !c.selected;
    c.Children = c.Children.map(d => selectAllCategory(d, c.selected));
  } 
  else {
    c.Children = c.Children.map(d => selectCategory(d, ID));
  }
  return c
}

function selectAllCategory(category, selected) {
  var c = Object.assign({}, category)
  c.selected = selected;
  c.Children = c.Children.map(d => selectAllCategory(d, selected));
  return c
}

function selectCategoriesFromResult(categories, result, selectedCateg) {
  var resultSet = new Set(result.filter(x => x).map(x => parseInt(x.CategoryID)))
  var selectedSet = new Set(selectedCateg.map(x => parseInt(x)));
  return [].concat(...categories.map(category => selectCategoriesFromSets(category, resultSet, selectedSet)))
}

function selectCategoriesFromSets(category, resultSet, selectedSet) {
  let id = parseInt(category.ID)
  if(selectedSet.has(id)) {
    category.selected = true
  }
  if(category.Children.length === 0) {
    if(resultSet.has(id) || selectedSet.has(id)) {
      return [category]
    }
    else {
      return []
    }
  }
  else {
    category.Children = [].concat(...category.Children.map(x => selectCategoriesFromSets(x, resultSet, selectedSet)))
    if(resultSet.has(id) || selectedSet.has(id)|| category.Children.length > 0) {
      category.expanded = true
      return [category]
    }
    else {
      return []
    }
  }
}

function getSelectedCategories(categories) {
  if(categories.length === 0)
    return [];
  return categories.filter(x => x.selected).map(x => x.ID).concat(...categories.map(c => getSelectedCategories(c.Children)))
}

function countCategories(categories) {
  if(categories.length === 0)
    return 0;
  return categories.map(c => 1+countCategories(c.Children)).reduce((x, y) => x+y, 0)
}

function resetCategories(setCategories, categoriesRef, lastCategoriesRef) {
  lastCategoriesRef.current = categoriesRef.current
  setCategories(categoriesRef.current.map(categoriesState))
}

function reset(setData, setManufacturers, setFilter, setCategories, setText, setOnlyAvailable, setOnlyPublished, categoriesRef, lastCategoriesRef, manufacturersRef) {
    setData(null)
    setManufacturers(manufacturersRef.current.map(x => {return {selected: false, manufacturer: x} }))
    setFilter("")
    lastCategoriesRef.current = categoriesRef.current
    setCategories(categoriesRef.current.map(categoriesState))
    setText("")
    setOnlyAvailable(false)
    setOnlyPublished(false)
  }

  function App() {
    const [data, setData] = useState(false)
    const [page, _setPage] = useState(0)
    const setPage = (x) => {
      _setPage(x)
      window.scrollTo(0,0);
    }
    // eslint-disable-next-line
    const [pageSize, _setPageSize] = useState(36)
    const [ordering, _setOrdering] = useState(null)
    const setOrdering = (x) => {
      _setOrdering(x)
      setPage(0)
    }
    const [onlyAvailable, setOnlyAvailable] = useState(false)
    const [onlyPublished, setOnlyPublished] = useState(false)
    const [text, setText] = useState('')
    const [manufacturers, _setManufacturers] = useState([])
    const manufacturersRef = useRef([])
    const lastManufacturersRef = useRef([])
    const setManufacturers = x => {
      lastManufacturersRef.current = x
      _setManufacturers(x)
    }
    const [manufacturersClosed, setManufacturersClosed] = useState(true)
    const [manufacturerFilterText, setManufacturerFilterText] = useState("")
    const [manufacturerFilter, setManufacturerFilter] = useState("")
    const [categoryFilterText, setCategoryFilterText] = useState("")
    const [categoryFilter, setCategoryFilter] = useState("")
    const [categories, setCategories] = useState([])
    const [categoriesClosed, setCategoriesClosed] = useState(true)
    const categoriesRef = useRef([])
    const lastCategoriesRef = useRef([])
    const [isLoading, setLoading] = useState(false)
    const [query, setQuery] = useSearchParams()
    const [evidenziaFiltri, setEvidenziaFiltri] = useState(false)
    const [from, _setFrom] = useState("")
    const [to, _setTo] = useState("")
    const setFrom = x => {
      let f = checkNum(from, x)
      _setFrom(f)
      if(parseFloat(f) > parseFloat(to))
        _setTo(f)
    }
    const setTo = x => {
      let t = checkNum(to, x)
      _setTo(t)
      if(parseFloat(t) < parseFloat(from))
        _setFrom(t)
    }
    const navigate = useNavigate()
    const search = () => {
      let q = text
      let cs = getSelectedCategories(categories).join('~')
      let ms = getSelectedManufacturers(manufacturers).join('~')
      let map = {}
      if(q.length > 0)
        map['q'] = q
      if(cs.length > 0)
        map['cs'] = cs
      if(ms.length > 0)
        map['ms'] = ms
      if(onlyAvailable)
        map['a'] = onlyAvailable
      if(onlyPublished)
        map['p'] = onlyPublished
      if(from.length > 0)
        map['f'] = from.replace(/\.$/, '')
      if(to.length > 0)
        map['t'] = to.replace(/\.$/, '')
      var qp = new URLSearchParams(map)
      setQuery(qp)
      setEvidenziaFiltri(false)
    }
    useEffect(() => {
      fetch(`${constants.baseUrl}/categories.php`)
      .then(response => {
        if(response.ok) {
          return response.json();
        }
        throw response;
      })
      .then(d => {
        console.log(lastCategoriesRef.current)
        if(!Array.isArray(lastCategoriesRef.current)  || lastCategoriesRef.current.length === 0)
          setCategories(d.map(categoriesState))
        categoriesRef.current = d
        lastCategoriesRef.current = d
      })
      .catch(e =>
        navigate('/error')
      )
      fetch(`${constants.baseUrl}/manufacturers.php`)
      .then(response => {
        if(response.ok) {
          return response.json();
        }
        throw response;
      })
      .then(d => {
        if(!Array.isArray(manufacturersRef.current)  || manufacturersRef.current.length === 0) {
          setManufacturers(d.map(x => {return {selected: false, manufacturer: x} }))
          manufacturersRef.current = d
        }
      })
      .catch(e =>
        navigate('/error')
      )
    }, [navigate])
    
  
    useEffect(() => {
      setCategories(filterCategories(categoriesRef.current, categoryFilter, lastCategoriesRef))
    }, [categoryFilter])

    useEffect(() => {
      _setManufacturers(lastManufacturersRef.current.filter(x => x.manufacturer.toLowerCase().includes(manufacturerFilter.toLowerCase())))
    }, [manufacturerFilter])
  
    useEffect(() => {
      let selectedManuf = [];
      let selectedCateg = [];
      if(query.has('q'))
        setText(query.get('q'))
      if(query.has('a')) {
        setOnlyAvailable(query.get('a') === 'true')
      }
      if(query.has('p')) {
        setOnlyPublished(query.get('p') === 'true')
      }
      if(query.has('ms')) {
        selectedManuf = query.get('ms').split('~');
      }
      if(query.has('cs')) {
        selectedCateg = query.get('cs').split('~');
      }
      var url = query.toString()
      if(url.length > 0) {
        setLoading(true);
        fetch(`${constants.baseUrl}/search.php?${url}`)
        .then(response => {
          if(response.ok) {
            return response.json();
          }
          throw response;
        })
        .then(d => {
          setTimeout(() => {
          setData(d)
          setManufacturers(manufacturersState(d, selectedManuf))
          setCategoryFilter("")
          lastCategoriesRef.current = selectCategoriesFromResult(categoriesRef.current.map(categoriesState), d, selectedCateg)
          setCategories(lastCategoriesRef.current)
          setLoading(false)
          setPage(0)
          }, 200)
        })
        .catch(e =>
          navigate('/error')
        )
      }
    }, [query, navigate])
  
    const order = data => {
      if(ordering === null)
        return data
      return data.sort((a, b) => ordering.on(a) - ordering.on(b))
    }

    return (
      <div
        className="App"
      >
        <section className="search-section">
          <div className="search-bar">
            <input
              className="search-input"
              type="text"
              placeholder='Cerca qui i prodotti di tuo interesse! es. "Notebook Ryzen", "Frullatore Verde", "Monitor Samsung" oppure incolla direttamente il codice prodotto o il nostro codice che inizia con VLX!'
              value={text}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  event.preventDefault();
                  search();
                }
              }}
              onChange={(event) => {
                event.preventDefault();
                setText(event.target.value);
              }}
            />
            <button className="search-button" onClick={() => search()}>
              <FontAwesomeIcon icon={faMagnifyingGlass} />
              Cerca
            </button>
            <button
              className="search-button"
              onClick={() =>
                reset(
                  setData,
                  setManufacturers,
                  setCategoryFilter,
                  setCategories,
                  setText,
                  setOnlyAvailable,
                  setOnlyPublished,
                  categoriesRef,
                  lastCategoriesRef,
                  manufacturersRef
                )
              }
            >
              <FontAwesomeIcon icon={faFilterCircleXmark} />
              Reset
            </button>
          </div>
        </section>
        <div className="filtri-checkbox">
          <div>
            <input
              type="checkbox"
              checked={onlyAvailable}
              name="onlyAvailable"
              onChange={() => {
                setEvidenziaFiltri(true);
                setOnlyAvailable(!onlyAvailable);
              }}
            />
            <label htmlFor="onlyAvailable">Solo disponibili</label>
          </div>
          <div>
            <input
              type="checkbox"
              checked={onlyPublished}
              name="onlyPublished"
              onChange={() => {
                setEvidenziaFiltri(true);
                setOnlyPublished(!onlyPublished);
              }}
            />
            <label htmlFor="onlyPublished">Solo pubblicati</label>
          </div>
          <PriceFilter
            from={from}
            to={to}
            open={false}
            fromChange={(x) => {
              setFrom(x);
              setEvidenziaFiltri(true);
            }}
            toChange={(x) => {
              setTo(x);
              setEvidenziaFiltri(true);
            }}
          />
        </div>
        {
          isLoading ? 
          <></>
          : 
          (<div className="dettaglio-risultati">
          {data ?
           (
            <button
              className={
                evidenziaFiltri ? "evidenziaFiltri" : "pulsante-filtri"
              }
              onClick={() => search()}
            >
              Applica filtri
            </button>
          ) : (
           <></>
          )}
          {
            data 
            ? 
              (<span className='count'><b>{text}</b> - {data.length} Risultat{data.length === 1 ? 'o' : 'i'}</span>)
            :
            <div>
            <SearchHints />
          </div>
          }
          {
            data
            ?
              <Sorter onChange={setOrdering} selected={ordering} />
            :
              <></>
          }
        </div>)
        }        
        {isLoading ? (
          <div>
            <Loader />
          </div>
        ) : (
          <div className="risultati">
            <div className="filtri">
              <div className={categoriesClosed && countCategories(categories) > 4 ? 'closed' : ''}>
                <span className="summary-title">Categorie</span>
                <div className="container-ricerca-filtri">
                  <input
                    className="ricerca-categorie"
                    name="categorySearchBox"
                    type="text"
                    placeholder='"Notebook", "CPU", "UPS", "SSD" ...'
                    value={categoryFilterText}
                    onKeyDown={(event) => {
                      if(event.key === 'Enter'){
                        event.preventDefault();
                        setCategoryFilter(categoryFilterText);
                      }
                    }}
                    onChange={(event) => {
                      event.preventDefault();
                      setCategoryFilterText(event.target.value);
                    }}
                  />
                  <button
                    className="search-button"
                    onClick={(event) => {
                      event.preventDefault();
                      setCategoryFilter(categoryFilterText);
                    }}
                  >
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                    Cerca
                  </button>
                  <button
                    className="reset-button"
                    onClick={(e) => {
                      e.preventDefault();
                      setCategoryFilter("");
                      setCategoryFilterText("");
                      resetCategories(
                        setCategories,
                        categoriesRef,
                        lastCategoriesRef
                      )
                    }
                    }
                  >
                    <FontAwesomeIcon icon={faFilterCircleXmark} />
                    Reset
                  </button>
                </div>
                <div className="categories-container">
                  {categories.map((c) => (
                    <Category
                      key={c.ID}
                      data={c}
                      onSelect={(id) => {
                        setEvidenziaFiltri(true);
                        setCategories(
                          categories.map((c) => selectCategory(c, id))
                        );
                      }}
                    />
                  ))}
                </div>
                {
                    countCategories(categories) > 4
                  ?
                    <div className={'expander '+(categoriesClosed ? 'closed' : '')}>
                      <button className='pulsante-mostra' onClick={(event) => {event.preventDefault(); setCategoriesClosed(!categoriesClosed)}}>{categoriesClosed ? "Mostra tutte" : "Mostra meno"}</button>
                    </div>
                  :
                    <></>
                }
              </div>
              <div className={manufacturersClosed && manufacturers.length > 4 ? 'closed' : ''}>
                <span className="summary-title">Produttori</span>
                <div className="container-ricerca-filtri">
                  <input
                    className="ricerca-categorie"
                    name="manufacturerSearchBox"
                    type="text"
                    placeholder='"Apple", "Samsung", "HP", "AMD"..."'
                    value={manufacturerFilterText}
                    onKeyDown={(event) => {
                      if(event.key === 'Enter'){
                        event.preventDefault();
                        setManufacturerFilter(manufacturerFilterText);
                      }
                    }}
                    onChange={(event) => {
                      event.preventDefault();
                      setManufacturerFilterText(event.target.value);
                    }}
                  />
                  <button
                    className="search-button"
                    onClick={(event) => {
                      event.preventDefault();
                      setManufacturerFilter(manufacturerFilterText);
                    }}
                  >
                    <FontAwesomeIcon icon={faMagnifyingGlass} />
                    Cerca
                  </button>
                  <button
                    className="reset-button"
                    onClick={(e) => {
                      e.preventDefault();
                      setManufacturers(lastManufacturersRef.current)
                    }
                    }
                  >
                    <FontAwesomeIcon icon={faFilterCircleXmark} />
                    Reset
                  </button>
                </div>
                <div className="categories-container">
                  {manufacturers.length > 0 ? (
                    <div>
                      {manufacturers.map((m) => (
                        <Manufacturer
                          key={m.manufacturer}
                          selected={m.selected}
                          manufacturer={m.manufacturer}
                          onSelect={(n) => {
                            setEvidenziaFiltri(true);
                            setManufacturers(
                              selectManufacturer(manufacturers, n)
                            );
                          }}
                        />
                      ))}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
                {
                    manufacturers.length > 4
                  ?
                    <div className={'expander '+(manufacturersClosed ? 'closed' : '')}>
                      <button className='pulsante-mostra' onClick={(event) => {event.preventDefault(); setManufacturersClosed(!manufacturersClosed)}}>{manufacturersClosed ? "Mostra tutti" : "Mostra meno"}</button>
                    </div>
                  :
                    <></>
                }
              </div>
            </div>
            <section className="sezione-risultati-ricerca">
              <div className="prodotti">
                {data && data.length > 0 ? (
                  <div
                    className={"controls modern"}
                  ></div>
                ) : (
                  <></>
                )}
                {data ? (
                  data.length > 0 ? (
                    <Modern
                      data={order(data).slice(
                        page * pageSize,
                        (page + 1) * pageSize
                      )}
                    />
                  ) : (
                    <div>Nessun risultato trovato.</div>
                  )
                ) : (
                  <></>
                )}
                {data && data.length > 0 ? (
                  <div
                    className={"controls modern"}
                  ></div>
                ) : (
                  <></>
                )}
              </div>
              <Pager
              page={page}
              pageSize={pageSize}
              setPage={setPage}
              count={data ? data.length : data}
            />
            </section>
            
          
          </div>
        )}
      </div>
    );
  }
  
  export default App;